const AcIsObject = value => {
  let type = typeof value;
  return !!value && (type === 'object' || type === 'function');
};

export default AcIsObject;
